import React, { useContext, useEffect, useState } from "react";
import { getMonth } from "../../../utils/calendarUtils";
import GlobalContext from "../../../context/GlobalCalendarContext";
import { useProjects } from "../../../context/ProjectsContext";
import { collection, query, where, getDocs } from "firebase/firestore";
import { db } from "../../../components/Auth/firebase";

import Sidebar from "./Sidebar";
import Month from "./Month";
import CalendarHeader from "./CalendarHeader";
import EventModal from "./EventModal";

const CalendarView = () => {
  const [currentMonth, setCurrentMonth] = useState(getMonth());
  const { monthIndex, showEventModal } = useContext(GlobalContext);
  const { activeProject } = useProjects(); // Using the active project context
  const [events, setEvents] = useState([]); // State to hold events specific to the selected project

  useEffect(() => {
    setCurrentMonth(getMonth(monthIndex));
  }, [monthIndex]);

  useEffect(() => {
    const fetchEventsForProject = async () => {
      if (activeProject && activeProject.id) {
        // Ensure activeProject and its id are not null
        console.log("Project ID for query:", activeProject.id);
        const eventsCol = collection(db, "events");
        const q = query(eventsCol, where("projectId", "==", activeProject.id));
        const eventSnapshot = await getDocs(q);
        const fetchedEvents = eventSnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        console.log(`Fetched ${eventSnapshot.docs.length} events`);
        setEvents(fetchedEvents);
      } else {
        console.log("Active project or project ID is null");
        setEvents([]); // Optionally clear events or handle the state appropriately
      }
    };

    fetchEventsForProject().catch((error) =>
      console.error("Failed to fetch events:", error)
    );
  }, [activeProject?.id]); // Depend on activeProject.id safely

  return (
    <React.Fragment>
      {showEventModal && <EventModal />}
      <div className="h-screen flex flex-col">
        <CalendarHeader />
        <div className="flex flex-1">
          <Sidebar />
          <Month month={currentMonth} events={events} />
        </div>
      </div>
    </React.Fragment>
  );
};

export default CalendarView;
